import type { ReactNode } from 'react';

export const symbol_lightbulb_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M385-240q-24.75 0-42.37-17.63Q325-275.25 325-300v-67q-59.37-40.02-92.19-102.61Q200-532.2 200-603q0-115.75 82-196.37Q364-880 480.5-880t198 81.5Q760-717 760-600q0 71-33 132.5T635-367v67q0 24.75-17.62 42.37Q599.75-240 575-240H385Zm5-60h180v-78q0-8 3.5-14t9.5-11l23-16q44.81-30.95 69.41-79.03Q700-546.11 700-600.26 700-692 636-756q-64-64-156-64t-156 64.61q-64 64.61-64 156.27 0 54.12 24.59 101.78Q309.19-449.68 354-419l23 16q6 5 9.5 11t3.5 14v78Zm7 220q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h167q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q576.75-80 564-80H397Zm83-520Z"
		/>
	</svg>
);
